module.exports = __webpack_public_path__ + "6aa68c9181c17718df257ff4e130319e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-circus.png
// module id = 3425
// module chunks = 0